import { cn } from '@/utils/cn'

/** Campos do agendamento SQL — apenas borda amarela, fundo padrão do painel. */
export const agendarFieldShellClass = cn(
  'field-attention-shell min-h-[52px] w-full rounded-lg border-2 border-warning bg-white/[0.04] px-3 py-2.5',
  'transition-colors hover:border-warning/80 hover:bg-white/[0.06]',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warning/30',
)

export const agendarFieldLabelClass =
  'text-[10px] font-medium uppercase tracking-wider text-text-label'

export const agendarFieldIconWrapClass =
  'flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-white/[0.06] text-accent'

/** Controle dentro do shell amarelo (select/input) — sem borda própria. */
export const agendarFieldInnerControlClass =
  'w-full cursor-pointer border-0 bg-transparent p-0 text-sm font-medium text-text-primary outline-none focus:ring-0'

/** Textarea dentro do shell amarelo. */
export const agendarFieldInnerTextareaClass =
  'w-full resize-none border-0 bg-transparent p-0 text-sm text-text-primary outline-none focus:ring-0'

/** Shell compacto para selects BANT (mesmo padrão de Tipo de reunião). */
export const attentionSelectShellClass = cn(
  agendarFieldShellClass,
  'flex min-h-[44px] items-center py-2',
)

/** Shell para textarea BANT. */
export const attentionTextareaShellClass = cn(
  agendarFieldShellClass,
  'min-h-[88px] block px-3 py-2.5',
)
